import { lazy } from 'react';
const orderqramendment = lazy(() => import('./orderqramendment'));

const orderqramendmentRoutes = [
  {
    path: '/orderqramendment',
    component: orderqramendment
  }
];
export default orderqramendmentRoutes;